/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreUnsubscribe } from '@atlassian/react-sweet-state';
import { getResourceStore } from '../resource-store/index.tsx';

export const addResourcesListener = (fn: (...args: any) => any): StoreUnsubscribe =>
	getResourceStore().storeState.subscribe(fn);
